import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconLlmCheck = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-llm-check" data-icon="icon-llm-check" aria-hidden="true" {...props} ref={ref}><path d="M20 6 9 17l-5-5"/></svg>);
});

IconLlmCheck.displayName = 'IconLlmCheck';
